import { create } from 'zustand'

export interface PresenceUser {
  userId: number
  name: string
  email?: string
  color: string
  editing?: { tableId?: string | null } | null
}

interface PresenceState {
  status: 'idle' | 'connecting' | 'connected' | 'disconnected'
  users: Record<number, PresenceUser>
  setStatus: (status: PresenceState['status']) => void
  upsertUser: (user: PresenceUser) => void
  removeUser: (userId: number) => void
  clear: () => void
}

export const usePresenceStore = create<PresenceState>((set) => ({
  status: 'idle',
  users: {},
  setStatus: (status) => set({ status }),
  upsertUser: (user) => set((state) => ({ users: { ...state.users, [user.userId]: user } })),
  removeUser: (userId) =>
    set((state) => {
      const next = { ...state.users }
      delete next[userId]
      return { users: next }
    }),
  clear: () => set({ status: 'idle', users: {} }),
}))
